import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {UnitsModel} from '../../../../models/UnitsModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-units-filter',
  templateUrl: './units-filter.component.html',
  styleUrls: ['./units-filter.component.scss']
})
export class UnitsFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterUnits: any[];

  @Input() unitsData: any;
  @Input() unitsSelected: UnitsModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('unitsData' in changes) {
      this.listFilterUnits = this.unitsData ? this.unitsData : [];
      this.optionSelected = null;
    }
    if (this.unitsSelected) {
      this.optionSelected = this.unitsSelected;
    }
  }

  ngOnDestroy(): void {
  }

}
